import styled from 'styled-components';

export default styled.div`
  &:after {
    content: "*";
    color: #FF5D4C
  }
`;
